import { ArrowBack } from "@mui/icons-material";
import { Box, Container, Link, Typography } from "@mui/material";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Link as RouterLink } from "react-router-dom";
import remarkGfm from "remark-gfm";
import termsOfServiceContent from "../../assets/content/terms-of-service.md?raw";

export const TermsOfService: React.FC = () => {
	return (
		<Box
			sx={{
				minHeight: "100vh",
				bgcolor: "grey.50",
				py: { xs: 3, sm: 6 },
			}}
		>
			<Container component="main" maxWidth="md">
				{/* Header */}
				<Box sx={{ mb: 6 }}>
					<Link
						component={RouterLink}
						to="/login"
						sx={{
							display: "inline-flex",
							alignItems: "center",
							color: "primary.main",
							textDecoration: "none",
							fontSize: "0.875rem",
							fontWeight: 500,
							mb: 3,
							"&:hover": {
								textDecoration: "underline",
							},
						}}
					>
						<ArrowBack sx={{ fontSize: 16, mr: 1 }} />
						Back to Sign In
					</Link>

					<Typography
						variant="body1"
						sx={{
							color: "grey.600",
							fontSize: "1rem",
						}}
					>
						Last updated: {new Date().toLocaleDateString()}
					</Typography>
				</Box>

				{/* Markdown Content */}
				<Box
					sx={{
						bgcolor: "common.white",
						borderRadius: 2,
						p: { xs: 3, sm: 4, md: 6 },
						boxShadow: 1,
						// Styling for markdown elements
						"& h1": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: { xs: "2rem", sm: "2.5rem" },
							mb: 4,
							mt: 0,
						},
						"& h2": {
							fontWeight: 600,
							color: "grey.900",
							fontSize: "1.5rem",
							mt: 5,
							mb: 2,
							"&:first-of-type": {
								mt: 3,
							},
						},
						"& p": {
							fontSize: "1rem",
							lineHeight: 1.7,
							color: "grey.700",
							mb: 3,
						},
						"& ul": {
							pl: 3,
							color: "grey.700",
							mb: 3,
						},
						"& li": {
							mb: 1,
							fontSize: "1rem",
							lineHeight: 1.7,
						},
						"& hr": {
							border: "none",
							borderTop: "1px solid",
							borderColor: "divider",
							my: 4,
						},
					}}
				>
					<ReactMarkdown remarkPlugins={[remarkGfm]}>
						{termsOfServiceContent}
					</ReactMarkdown>
				</Box>
			</Container>
		</Box>
	);
};
